var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.resolveLayout,{tag:"component"},[_c('router-view')],1),_c('TheLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }